import styled, { CreateStyled } from "@emotion/styled";

type Theme = {
  color: {
    primary: string;
    secondary: string;
    danger: string;
    dark: string;
    warning: string;
    black: string;
    white: string;
  };
  font: {
    family: string;
    tileLineHight: string;
    pLineHight: string;
    buttonLineHight: string;
    bigLineHight: string;
    midiumLineHight: string;
    miniLineHight: string;
  };
};

export const theme = {
  color: {
    primary: "#3B528C",
    secondary: "#3B8C79",
    danger: "#8C3B62",
    dark: "#515151",
    warning: "#E26363",
    black: "#333333",
    white: "#ffffff",
  },
  font: {
    family: "Noto Sans JP",
    tileLineHight: "35px",
    pLineHight: "150%",
    buttonLineHight: "20px",
    bigLineHight: "23px",
    midiumLineHight: "17px",
    miniLineHight: "14px",
  },
};

export default styled as CreateStyled<Theme>;
